import { html, TemplateResult, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import globalStyles from './styles/outline-image.global.pcss?inline';
import encapsulatedStyles from './styles/outline-image.encapsulated.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';

/**
 * The element name, reused throughout the codebase
 * @type {string}
 */
const componentName = 'outline-image';

/**
 * The Outline Core Image component
 *
 * A reusable LitElement component for displaying images.
 *
 * @element outline-image
 * @extends LitElement
 * @slot - Placeholder for image to be inserted into the component
 */
@customElement(componentName)
export class OutlineImage extends LitElement {
  /**
   * Adopted stylesheets for the component
   *
   * @type {AdoptedStyleSheets}
   */
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: encapsulatedStyles,
  });

  /**
   * Render method to define the component's template
   *
   * @returns {TemplateResult} A lit-html TemplateResult object representing the component's template
   */
  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}

/**
 * Declare the component in the global HTMLElementTagNameMap
 */
declare global {
  interface HTMLElementTagNameMap {
    [componentName]: OutlineImage;
  }
}
